export const TRANSFORM_TYPES = {
  ROTATE: 'rotate',
  SIZE: 'size',
  FLIP: 'flip',
};

export const MENU_TYPES = {
  MAIN: 'main',
  TRANSFORM: 'transform',
  FILTERS: 'filters',
};
